import e from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import p from "./iconfont.es5471.js";
const r = {
  display: "block"
}, x = ({ size: a = 16, useVw: n, useRem: o, color: c, withColor: l, removeClassName: t, disableSSR: d, style: h, ...m }) => {
  const v = h ? { ...r, ...h } : r;
  return /* @__PURE__ */ e.createElement(p, { disableSSR: d }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-heyuezhongxin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: v, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-åçº¦ä¸­å¿"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: l ? i(c, 0, "#262933") : "#262933",
        datafollowfill: l ? i(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M13.794 22.207a.9.9 0 0 1 .9-.9h6.425a.9.9 0 1 1 0 1.8h-6.425a.9.9 0 0 1-.9-.9Zm.826-5.038a.9.9 0 0 0 0 1.8h3.104a.9.9 0 1 0 0-1.8h-3.103Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M9.024 23.704h.612v.612a3.923 3.923 0 0 0 3.924 3.924h9.416a3.923 3.923 0 0 0 3.924-3.924v-9.202a2.41 2.41 0 0 0-.707-1.705L21.79 9.005v-.001a2.405 2.405 0 0 0-1.282-.67v-.65a3.923 3.923 0 0 0-3.924-3.924h-7.56A3.923 3.923 0 0 0 5.1 7.684V19.78a3.923 3.923 0 0 0 3.924 3.924Zm0-18.143A2.121 2.121 0 0 0 6.9 7.684V19.78c0 1.173.95 2.124 2.124 2.124h.612V12.22a3.923 3.923 0 0 1 3.924-3.924h5.147v-.612c0-1.173-.95-2.123-2.123-2.123h-7.56Zm2.412 17.243v1.512c0 1.173.95 2.123 2.124 2.123h9.416c1.174 0 2.124-.95 2.124-2.123v-8.172h-3.98a2.412 2.412 0 0 1-2.413-2.412v-3.636H13.56c-1.174 0-2.124.95-2.124 2.124v10.584Zm9.071-12.536v3.464c0 .338.275.612.612.612h3.464l-4.068-4.068-.002-.002-.006-.006Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = x;
export {
  s as default
};
